import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import { useFreeProxyData } from "../store/freeProxy/freeProxy.selectors";

//  only for select
export const useSetValueFromQuery = (
  data,
  queryValue,
  setSelectedItem,
  allOption,
  selectOption,
  selectedItem,
) => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const { cities } = useFreeProxyData();

  const isCities = allOption?.name === t("global.allCities");
  const selectedCountry = searchParams.get("country") || "";

  useEffect(() => {
    // if types return

    if (data?.some(item => item?.id === "IPv4")) return;

    // logic only for countries and cities

    // ---------- new
    if (selectedItem && !selectedCountry) {
      setSelectedItem(allOption);
    }
    // -------------------

    if (data && queryValue) {
      const foundItem =
        data.find(
          item => String(item[selectOption]) === decodeURIComponent(queryValue),
        ) || null;

      setSelectedItem(foundItem);
    } else if ((selectedCountry || !!cities.length) && isCities) {
      setSelectedItem(allOption);
    }
  }, [data, queryValue]);

  useEffect(() => {
    // logic only for types (because getting types synchronously)
    if (data?.some(item => item?.id === "IPv4") && queryValue) {
      const foundItem = data.find(
        item => String(item[selectOption]) === queryValue,
      );
      setSelectedItem(foundItem);
    }
  }, []);
};
